import type { CategoryDefinition } from '@/types';
import { carDetailingCategories } from './car-detailing';
import { electricianCategories } from './electrician';
import { homeCleaningCategories } from './home-cleaning';
import { hvacCategories } from './hvac';
import { lawnCareCategories } from './lawn-care';
import { otherCategories } from './other';
import { plumbingCategories } from './plumbing';
import { pressureWashingCategories } from './pressure-washing';
import { salonSpaCategories } from './salon-spa';

export const CATEGORY_SETS: Readonly<Record<string, readonly CategoryDefinition[]>> = {
  'car-detailing': carDetailingCategories,
  'pressure-washing': pressureWashingCategories,
  plumbing: plumbingCategories,
  electrician: electricianCategories,
  hvac: hvacCategories,
  'lawn-care': lawnCareCategories,
  'home-cleaning': homeCleaningCategories,
  'salon-spa': salonSpaCategories,
  other: otherCategories,
};

export {
  carDetailingCategories, electricianCategories, homeCleaningCategories, hvacCategories,
  lawnCareCategories, otherCategories, plumbingCategories, pressureWashingCategories,
  salonSpaCategories,
};
